import styled from 'styled-components/native';
import { Text } from 'react-native';

import { FOHColors } from '../colors/FOHColors';

import { FOHFonts } from './FOHFonts';

export const FOHBannerText = styled(Text)`
  font-family: ${FOHFonts.MEDIUM};
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 140%;
  align-items: center;
  color: ${FOHColors.WHITE}
  padding-left: 6px;
`;
